import reducer from "./reducer";
export { default as DivisionsSettings } from "./components/index";
export { default as divisionsSettingsReducerName } from "./constants";
export default reducer;
